import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
    Container, Row, Col, Modal, ModalHeader, ModalBody,
    ModalFooter, Card, CardBody, Button, Form, FormGroup,
    Label, Input, InputGroup, InputGroupText, FormFeedback,
    Badge, Alert
} from 'reactstrap';
import MaterialTable from '@material-table/core';
import axios from 'axios';
import { Add, Edit, Delete } from '@material-ui/icons';
import swal from 'sweetalert';
import moment from 'moment';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';

import backend_url from "../../../routes/API_URL";
import Loader from "../../../components/Loader";

const API_URL = backend_url['api_url'];

class InspectionVisits extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            // User info
            role: window.sessionStorage.getItem("urole"),
            bearer_auth: window.sessionStorage.getItem('token'),
            logged_user_id: window.sessionStorage.getItem('uid'),
            sector_id: window.sessionStorage.getItem("sector"),

            // Modal states
            modalVisible: false,
            modalAdminVisible: false,
            EditModalVisible: false,
            EditAdminModalVisible: false,
            toggleCalendar: false,
            showOptions: true,

            // Optimized pagination states
            page: 0,
            pageSize: 10,
            totalCount: 0,
            searchText: '',
            loading: false,
            isFetching: false,
            error: null,
            rawResponse: null,

            // Data states
            Visits: [],
            VisitTypes: [],
            Users: [],
            Sectors: [],
            Districts: [],
            Zones: [],
            Divisions: [],
            Schools: [],
            years: [],

            // Form states
            id: '',
            school_id: '',
            zone_id: '',
            district_id: '',
            division_id: '',
            visit_id: '',
            head_teacher: '',
            phone_number: '',
            present_visitation_date: moment().format("YYYY-MM-DD"),
            prev_visitation_date: '',
            lead_inspector_id: '',
            first_inspector_id: '',
            second_inspector_id: '',
            third_inspector_id: '',
            fourth_inspector_id: '',
            school_address: '',
            establishment_year: '',
            establishment: '',
            enrolment_boys: '',
            enrolment_girls: '',
            attendance_boys: '',
            attendance_girls: '',
            number_of_teachers: '',
            unqualified_teachers: '',
            action_plan_date: '',
            next_inspection_date: '',
            lead_advisor_id: '',
            govt_chair_id: '',
            visit_type_id: 1,
            expiry_date: '',

            // Stepper states
            activeStep: 0,
            completed: {},

            // Validation states
            EmisIdState: '',
            ZoneIdState: '',
            DistrictIdState: '',
            DivisionIdState: '',
            HeadTeacherIdState: '',
            presentDateState: '',
            prevDateState: '',
            leadInspectorIdState: '',
            firstInspectorIdState: '',
            secondInspectorIdState: '',
            thirdInspectorIdState: '',
            fourthInspectorIdState: '',
            SchoolAddressState: '',
            EstYearState: '',
            EstState: '',
            EnrolledBoysState: '',
            EnrolledGirlsState: '',
            AttendanceBoysState: '',
            AttendanceGirlsState: '',
            TotalTeachersState: '',
            UnqualifiedTeachersState: '',
            actionDateState: '',
            nextInspectionDateState: '',
            leadAdvisorIdState: '',
            govChairIdState: '',
            visitTypeIdState: '',
            attendanceError: '',
            attendanceGirlsError: '',

            // Other states
            visit: {},
            ExpiryVisitDate: '',
            expiryDateMessage: '',
            jurisdiction: '',
            isExpired: false
        };

        this.toggle = this.toggle.bind(this);
        this.toggleAdminEdit = this.toggleAdminEdit.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.addInspectionVisit = this.addInspectionVisit.bind(this);
        this.editInspectionVisit = this.editInspectionVisit.bind(this);
        this.updateInspectionVisit = this.updateInspectionVisit.bind(this);
        this.deleteInspectionVisit = this.deleteInspectionVisit.bind(this);
        this.filterDistrictsAfterLoad = this.filterDistrictsAfterLoad.bind(this);
        this.filterZonesAfterLoad = this.filterZonesAfterLoad.bind(this);
        this.filterSchoolsAfterLoad = this.filterSchoolsAfterLoad.bind(this);
        this.getRecentVisitBySchool = this.getRecentVisitBySchool.bind(this);
        this.toggleUpdateExpiryDate = this.toggleUpdateExpiryDate.bind(this);
        this.updateExpiryDate = this.updateExpiryDate.bind(this);
        this.setId = this.setId.bind(this);
        this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.viewVisitDetails = this.viewVisitDetails.bind(this);
    }

    componentDidMount() {
        this.fetchInitialData();
        this.getYears();
    }

    // Fetch initial dropdown data
    fetchInitialData = () => {
        const bearer_auth = this.state.bearer_auth;

        Promise.all([
            axios.get(API_URL + '/divisions', {
                headers: { "Authorization": `Bearer ${bearer_auth}` }
            }),
            axios.get(API_URL + '/sectors', {
                headers: { "Authorization": `Bearer ${bearer_auth}` }
            }),
            axios.get(API_URL + '/visit_types', {
                headers: { "Authorization": `Bearer ${bearer_auth}` }
            }),
            axios.get(API_URL + '/users', {
                headers: { "Authorization": `Bearer ${bearer_auth}` }
            })
        ])
            .then(([divisions, sectors, visitTypes, users]) => {
                this.setState({
                    Divisions: divisions.data || [],
                    Sectors: sectors.data || [],
                    VisitTypes: visitTypes.data || [],
                    Users: users.data || []
                });
            })
            .catch(error => {
                console.error('Error fetching initial data:', error);
            });
    }

    // Optimized fetchData method with server-side pagination
    fetchData = (page = 0, pageSize = this.state.pageSize, search = '') => {
        return new Promise((resolve, reject) => {
            this.setState({ isFetching: true, error: null });

            const bearer_auth = this.state.bearer_auth;
            const role = this.state.role;

            // Determine the endpoint based on user role
            let endpoint = '/inspection_visits';
            const params = {
                page: page + 1,
                per_page: pageSize,
                search: search || '',
                sort_by: 'present_visitation_date',  // Add this
                sort_order: 'DESC'
            };

            // Role-based filtering
            if (role === 'Division Manager') {
                const div_id = window.sessionStorage.getItem('division');
                endpoint = `/inspection_visits/division/${div_id}`;
            } else if (role === 'DEM') {
                const dist_id = window.sessionStorage.getItem('district');
                endpoint = `/inspection_visits/district/${dist_id}`;
            } else if (role === 'Secondary Advisor' || role === 'PEA') {
                const zon_id = window.sessionStorage.getItem('zone');
                endpoint = `/inspection_visits/zone/${zon_id}`;
            } else if (role === 'Head Teacher') {
                const sch_id = window.sessionStorage.getItem('school_id');
                endpoint = `/inspection_visits/school/${sch_id}`;
            }

            axios.get(API_URL + endpoint, {
                headers: {
                    "Authorization": `Bearer ${bearer_auth}`,
                    "Accept": "application/json"
                },
                params: params
            })
                .then(response => {
                    const data = response.data;

                    if (data.status === 'error') {
                        throw new Error(data.message || 'Failed to fetch inspection visits');
                    }

                    const visitsData = data.data || [];
                    const totalCount = data.total || 0;

                    this.setState({
                        Visits: visitsData,
                        totalCount: totalCount,
                        page: page,
                        pageSize: pageSize,
                        loading: false,
                        isFetching: false,
                        rawResponse: data,
                        jurisdiction: this.getJurisdictionText()
                    }, () => {
                        resolve({
                            data: visitsData,
                            page: page,
                            totalCount: totalCount
                        });
                    });
                })
                .catch(error => {
                    console.error('Error fetching inspection visits:', error);
                    this.handleApiError(error);
                    reject(error);
                });
        });
    }

    // Optimized API error handling
    handleApiError = (error) => {
        const errorMessage = error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Failed to load inspection visits";

        this.setState({
            loading: false,
            isFetching: false,
            error: errorMessage
        });

        if (error.response?.status === 401) {
            swal({
                title: "",
                text: "Your session has expired. You'll automatically be logged out within seconds.",
                icon: "warning",
                timer: 2000
            }).then(() => {
                window.sessionStorage.clear();
                window.location.reload();
            });
        } else {
            swal({
                title: "Error",
                text: errorMessage,
                icon: "error",
                button: true
            });
        }
    }

    // Get jurisdiction text
    getJurisdictionText = () => {
        const role = this.state.role;
        const sector_id = this.state.sector_id;

        switch (role) {
            case 'Division Manager':
                const division = window.sessionStorage.getItem('division_name') ||
                    window.sessionStorage.getItem('division') || '';
                return `${division} Division's Inspection Visits`;
            case 'DEM':
                const district = window.sessionStorage.getItem('district_name') ||
                    window.sessionStorage.getItem('district') || '';
                return `${district} District's Inspection Visits`;
            case 'Secondary Advisor':
                const zone1 = window.sessionStorage.getItem('zone_name') ||
                    window.sessionStorage.getItem('zone') || '';
                return `${zone1} Cluster's Inspection Visits`;
            case 'PEA':
                const zone2 = window.sessionStorage.getItem('zone_name') ||
                    window.sessionStorage.getItem('zone') || '';
                return `${zone2} Zone's Inspection Visits`;
            case 'Head Teacher':
                const school = window.sessionStorage.getItem('school_name') ||
                    window.sessionStorage.getItem('school_id') || '';
                return `${school} School's Inspection Visits`;
            default:
                return "National Inspection Visits";
        }
    }

    // View visit details modal
    viewVisitDetails = (visit) => {
        const details = `
School: ${visit.school_name}
EMIS ID: ${visit.emis_id || 'N/A'}
Date: ${new Date(visit.present_visitation_date).toLocaleDateString()}
Visit Type: ${visit.visit_type_description || 'Inspection'}
Head Teacher: ${visit.head_teacher}
Phone: ${this.formatPhoneNumber(visit.phone_number)}
School Address: ${visit.school_address || 'N/A'}

Zone/Cluster: ${visit.zone_name}
District: ${visit.district_name}
Division: ${visit.division_name}
Sector: ${visit.sector_name || 'N/A'}

Establishment Year: ${visit.establishment_year || 'N/A'}
Establishment Type: ${visit.establishment || 'N/A'}

Enrollment:
  - Boys: ${visit.enrolment_boys || 0}
  - Girls: ${visit.enrolment_girls || 0}
  - Total: ${(parseInt(visit.enrolment_boys) || 0) + (parseInt(visit.enrolment_girls) || 0)}

Attendance:
  - Boys: ${visit.attendance_boys || 0}
  - Girls: ${visit.attendance_girls || 0}

Teachers:
  - Qualified: ${visit.number_of_teachers || 0}
  - Unqualified: ${visit.unqualified_teachers || 0}
  - Total: ${(parseInt(visit.number_of_teachers) || 0) + (parseInt(visit.unqualified_teachers) || 0)}

Dates:
  - Previous Visit: ${visit.prev_visitation_date ? new Date(visit.prev_visitation_date).toLocaleDateString() : 'N/A'}
  - Action Plan: ${visit.action_plan_date ? new Date(visit.action_plan_date).toLocaleDateString() : 'N/A'}
  - Next Inspection: ${visit.next_inspection_date ? new Date(visit.next_inspection_date).toLocaleDateString() : 'N/A'}
  - Expiry: ${visit.expiry_date ? new Date(visit.expiry_date).toLocaleDateString() : 'N/A'}
  - Status: ${this.getVisitStatus(visit.expiry_date).text}
        `;

        swal({
            title: "Visit Details",
            text: details,
            icon: "info",
            content: document.createElement('pre'),
            buttons: {
                close: {
                    text: "Close",
                    value: "close"
                }
            }
        });
    }

    // Format phone number for display
    formatPhoneNumber = (phone) => {
        if (!phone) return 'N/A';
        if (phone.startsWith('+')) return phone;
        if (phone.startsWith('265')) return '+' + phone;
        return '+265' + phone;
    }

    // Get status badge color
    getVisitStatus = (expiryDate) => {
        if (!expiryDate) return { color: 'secondary', text: 'No Expiry' };

        const expiry = new Date(expiryDate);
        const today = new Date();

        if (expiry < today) {
            return { color: 'danger', text: 'Expired' };
        } else if (expiry < new Date(today.setDate(today.getDate() + 7))) {
            return { color: 'warning', text: 'Expiring Soon' };
        } else {
            return { color: 'success', text: 'Active' };
        }
    }

    // Toggle modals
    toggle() {
        this.setState(prevState => ({
            modalVisible: !prevState.modalVisible,
            EditModalVisible: false,
            school_id: '',
            zone_id: '',
            district_id: '',
            division_id: '',
            head_teacher: '',
            phone_number: '',
            present_visitation_date: moment().format("YYYY-MM-DD"),
            prev_visitation_date: '',
            lead_inspector_id: '',
            first_inspector_id: '',
            second_inspector_id: '',
            third_inspector_id: '',
            fourth_inspector_id: '',
            school_address: '',
            establishment_year: '',
            establishment: '',
            enrolment_boys: '',
            enrolment_girls: '',
            attendance_boys: '',
            attendance_girls: '',
            number_of_teachers: '',
            unqualified_teachers: '',
            action_plan_date: '',
            next_inspection_date: '',
            lead_advisor_id: '',
            govt_chair_id: '',
            visit_type_id: 1,
            activeStep: 0,
            completed: {},
            Districts: [],
            Zones: [],
            Schools: []
        }));
    }

    toggleAdminEdit(visit = null) {
        if (visit) {
            this.setState({
                EditAdminModalVisible: true,
                visit: visit,
                expiry_date: visit.expiry_date
            });
        } else {
            this.setState({
                EditAdminModalVisible: false,
                toggleCalendar: false,
                showOptions: true,
                expiry_date: ''
            });
        }
    }

    toggleUpdateExpiryDate() {
        this.setState({
            toggleCalendar: true,
            showOptions: false
        });
    }

    validatePhoneNumber = (phoneNumber) => {
        const cleaned = phoneNumber.replace(/\D/g, '');

        // Malawi phone numbers are 7-9 digits after +265
        if (cleaned.length >= 7 && cleaned.length <= 9) {
            return 'has-success';
        }
        return 'has-danger';
    }

    // Form input handler
    handleInput(e) {
        const { name, value, id } = e.target;

        // Update the field value
        this.setState({ [id]: value });

        if (name === 'phone_number') {
            // Validate phone number
            const phoneRegex = /^[0-9]{7,9}$/;
            if (value !== '' && phoneRegex.test(value)) {
                this.setState({ PhoneState: 'has-success' });
            } else {
                this.setState({ PhoneState: 'has-danger' });
            }
            return;
        }

        // Validation logic
        if (name === 'expiry_date' && value !== '') {
            const currentExpiryDate = new Date();
            const newExpiryDate = new Date(value);
            if (newExpiryDate < currentExpiryDate) {
                this.setState({
                    ExpiryVisitDate: 'has-danger',
                    expiryDateMessage: 'Expiry date cannot be set to a past date'
                });
            } else {
                this.setState({ ExpiryVisitDate: 'has-success' });
            }
        } else if (name === 'present_visitation_date') {
            if (value !== '' && !moment(value).isAfter(moment())) {
                this.setState({ presentDateState: 'has-success' });
            } else {
                this.setState({ presentDateState: 'has-danger' });
            }
        } else if (value !== '') {
            // Set success state for non-empty fields
            const stateName = name.charAt(0).toUpperCase() + name.slice(1) + 'State';
            if (this.state.hasOwnProperty(stateName)) {
                this.setState({ [stateName]: 'has-success' });
            }
        } else {
            // Set danger state for empty required fields
            const stateName = name.charAt(0).toUpperCase() + name.slice(1) + 'State';
            if (this.state.hasOwnProperty(stateName)) {
                this.setState({ [stateName]: 'has-danger' });
            }
        }
    }

    // Filter functions
    filterDistrictsAfterLoad(e) {
        const divisionId = e.target.value;
        this.setState({ division_id: divisionId }, () => {
            axios.get(API_URL + `/districts/filter/${divisionId}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            })
                .then(response => {
                    this.setState({ Districts: response.data || [] });
                })
                .catch(error => {
                    this.handleApiError(error);
                });
        });
    }

    filterZonesAfterLoad(e) {
        const districtId = e.target.value;
        this.setState({ district_id: districtId }, () => {
            axios.get(API_URL + `/zones/filter/${districtId}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            })
                .then(response => {
                    this.setState({ Zones: response.data || [] });
                })
                .catch(error => {
                    this.handleApiError(error);
                });
        });
    }

    filterSchoolsAfterLoad(e) {
        const zoneId = e.target.value;
        this.setState({ zone_id: zoneId }, () => {
            axios.get(API_URL + `/schools/filter/${zoneId}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            })
                .then(response => {
                    // Check if response has a data property (pagination response)
                    if (response.data && response.data.data) {
                        // Handle paginated response structure
                        this.setState({ Schools: response.data.data || [] });
                    } else if (Array.isArray(response.data)) {
                        // Handle array response
                        this.setState({ Schools: response.data });
                    } else {
                        // Handle other response structures or set empty array
                        this.setState({ Schools: [] });
                    }
                })
                .catch(error => {
                    console.error('Error fetching schools:', error);
                    this.setState({ Schools: [] });
                });
        });
    }

    getRecentVisitBySchool(e) {
        const emisId = e.target.value;
        axios.get(API_URL + `/inspection_visits/recent/${emisId}`, {
            headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
        })
            .then(response => {
                this.setState({
                    prev_visitation_date: response.data?.present_visitation_date || ''
                });
            })
            .catch(error => {
                console.error('Error fetching recent visit:', error);
            });
    }

    // Get years for establishment year dropdown
    getYears() {
        const years = [];
        for (let i = new Date().getFullYear(); i >= 1500; i--) {
            years.push(i);
        }
        this.setState({ years });
    }

    // Set ID
    setId(e) {
        this.setState({ [e.target.id]: e.target.value });
    }

    // Edit inspection visit
    editInspectionVisit(id) {
        this.setState({ loading: true });

        const visit = this.state.Visits.find(v => v.visit_id === id);
        if (!visit) return;

        // Fetch filtered data first
        Promise.all([
            axios.get(API_URL + `/districts/filter/${visit.division_id}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            }),
            axios.get(API_URL + `/zones/filter/${visit.district_id}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            }),
            axios.get(API_URL + `/schools/filter/${visit.zone_id}`, {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            })
        ])
            .then(([districts, zones, schools]) => {
                // Handle paginated response for schools
                let schoolsData = [];
                if (schools.data && schools.data.data) {
                    schoolsData = schools.data.data;
                } else if (Array.isArray(schools.data)) {
                    schoolsData = schools.data;
                }

                this.setState({
                    Districts: districts.data || [],
                    Zones: zones.data || [],
                    Schools: schoolsData,
                    id: visit.visit_id,
                    school_id: visit.school_id,
                    head_teacher: visit.head_teacher,
                    phone_number: visit.phone_number,
                    present_visitation_date: visit.present_visitation_date,
                    prev_visitation_date: visit.prev_visitation_date,
                    lead_inspector_id: visit.lead_inspector_id,
                    first_inspector_id: visit.first_inspector_id,
                    second_inspector_id: visit.second_inspector_id,
                    third_inspector_id: visit.third_inspector_id,
                    fourth_inspector_id: visit.fourth_inspector_id,
                    school_address: visit.school_address,
                    establishment_year: visit.establishment_year,
                    establishment: visit.establishment,
                    enrolment_boys: visit.enrolment_boys,
                    enrolment_girls: visit.enrolment_girls,
                    attendance_boys: visit.attendance_boys,
                    attendance_girls: visit.attendance_girls,
                    number_of_teachers: visit.number_of_teachers,
                    unqualified_teachers: visit.unqualified_teachers,
                    zone_id: visit.zone_id,
                    sector_id: visit.sector_id,
                    district_id: visit.district_id,
                    division_id: visit.division_id,
                    lead_advisor_id: visit.lead_advisor_id,
                    govt_chair_id: visit.govt_chair_id,
                    visit_type_id: visit.visit_type_id,
                    EditModalVisible: true,
                    modalVisible: true,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                this.handleApiError(error);
            });
    }

    // Update inspection visit
    updateInspectionVisit(event) {
        if (event) event.preventDefault();
        this.setState({ loading: true });

        const inspection = {
            school_id: this.state.school_id,
            head_teacher: this.state.head_teacher,
            phone_number: this.state.phone_number,
            present_visitation_date: this.state.present_visitation_date,
            prev_visitation_date: this.state.prev_visitation_date,
            lead_inspector_id: this.state.lead_inspector_id,
            first_inspector_id: this.state.first_inspector_id,
            second_inspector_id: this.state.second_inspector_id,
            third_inspector_id: this.state.third_inspector_id,
            fourth_inspector_id: this.state.fourth_inspector_id,
            school_address: this.state.school_address,
            establishment_year: this.state.establishment_year,
            establishment: this.state.establishment,
            enrolment_boys: this.state.enrolment_boys,
            enrolment_girls: this.state.enrolment_girls,
            attendance_boys: this.state.attendance_boys,
            attendance_girls: this.state.attendance_girls,
            number_of_teachers: this.state.number_of_teachers,
            unqualified_teachers: this.state.unqualified_teachers,
            zone_id: this.state.zone_id,
            sector_id: this.state.sector_id,
            district_id: this.state.district_id,
            division_id: this.state.division_id,
            lead_advisor_id: this.state.lead_advisor_id,
            govt_chair_id: this.state.govt_chair_id,
            visit_type_id: this.state.visit_type_id,
        };

        axios.patch(API_URL + `/inspection_visits/update/${this.state.id}`, inspection, {
            headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
        })

            .then(response => {
                if (response.data.status === 'success') {
                    swal({
                        title: "Success",
                        text: response.data.message,
                        icon: "success",
                        timer: 2500,
                        buttons: false
                    }).then(() => {
                        this.setState({ EditModalVisible: false, modalVisible: false, loading: false }, () => {
                            this.tableRef.current && this.tableRef.current.onQueryChange();
                        });
                    });
                } else {
                    swal({ title: "Error", text: response.data.message, icon: "error", button: true });
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                this.handleApiError(error);
            });
    }

    // Delete inspection visit
    deleteInspectionVisit(id) {
        swal({
            title: "Confirm Delete",
            text: "Are you sure you want to delete this inspection visit?",
            icon: "warning",
            dangerMode: true,
            buttons: ["Cancel", "Delete"]
        })
            .then(willDelete => {
                if (willDelete) {
                    this.setState({ loading: true });

                    axios.delete(API_URL + `/inspection_visits/delete/${id}`, {
                        headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
                    })
                        // deleteInspectionVisit - replace the .then() success block:
                        .then(response => {
                            swal({
                                title: "Deleted",
                                text: "Inspection visit deleted successfully!",
                                icon: "success",
                                timer: 2000
                            }).then(() => {
                                this.setState({ loading: false, page: 0 }, () => {
                                    this.tableRef.current && this.tableRef.current.onQueryChange();
                                });
                            });
                        })
                        .catch(error => {
                            this.setState({ loading: false });
                            this.handleApiError(error);
                        });
                }
            });
    }

    // Add inspection visit
    addInspectionVisit() {
        if (this.state.EditModalVisible === true) return this.updateInspectionVisit();

        // Validate all fields
        const requiredFields = [
            'DivisionIdState', 'DistrictIdState', 'ZoneIdState', 'EmisIdState',
            'HeadTeacherIdState', 'PhoneState', 'SchoolAddressState', 'EstYearState',
            'EstState', 'EnrolledBoysState', 'EnrolledGirlsState', 'TotalTeachersState',
            'UnqualifiedTeachersState', 'leadInspectorIdState', 'firstInspectorIdState',
            'secondInspectorIdState'
        ];

        const invalidFields = requiredFields.filter(field =>
            [undefined, 'has-danger'].includes(this.state[field])
        );

        if (invalidFields.length > 0) {
            return swal({
                title: '',
                text: "Please make sure all required fields are valid",
                icon: "error"
            });
        }

        this.setState({ loading: true });

        const inspection = {
            school_id: parseInt(this.state.school_id),
            head_teacher: this.state.head_teacher,
            phone_number: this.state.phone_number,
            present_visitation_date: this.state.present_visitation_date,
            prev_visitation_date: this.state.prev_visitation_date || null,
            lead_inspector_id: this.state.lead_inspector_id.toString(),
            first_inspector_id: this.state.first_inspector_id.toString(),
            second_inspector_id: this.state.second_inspector_id.toString(),
            third_inspector_id: this.state.third_inspector_id || null,
            fourth_inspector_id: this.state.fourth_inspector_id || null,
            school_address: this.state.school_address,
            establishment_year: parseInt(this.state.establishment_year),
            establishment: this.state.establishment,
            enrolment_boys: parseInt(this.state.enrolment_boys) || 0,
            enrolment_girls: parseInt(this.state.enrolment_girls) || 0,
            attendance_boys: parseInt(this.state.attendance_boys) || 0,
            attendance_girls: parseInt(this.state.attendance_girls) || 0,
            number_of_teachers: parseInt(this.state.number_of_teachers) || 0,
            unqualified_teachers: parseInt(this.state.unqualified_teachers) || 0,
            action_plan_date: moment(this.state.present_visitation_date).add(2, 'weeks').format("YYYY-MM-DD"),
            next_inspection_date: moment(this.state.present_visitation_date).add(6, 'months').format("YYYY-MM-DD"),
            zone_id: parseInt(this.state.zone_id),
            sector_id: parseInt(this.state.sector_id),
            district_id: parseInt(this.state.district_id),
            division_id: parseInt(this.state.division_id),
            lead_advisor_id: this.state.lead_advisor_id,
            govt_chair_id: this.state.govt_chair_id,
            visit_type_id: parseInt(this.state.visit_type_id),
        };

        axios.post(API_URL + '/inspection_visits', inspection, {
            headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
        })

            .then(response => {
                if (response.data.status === 'success') {
                    swal({
                        title: "Success",
                        text: response.data.message,
                        icon: "success",
                        timer: 2500,
                        buttons: false
                    }).then(() => {
                        this.setState({ modalVisible: false, loading: false, page: 0 }, () => {
                            this.tableRef.current && this.tableRef.current.onQueryChange();
                        });
                    });
                } else {
                    swal({ title: "Error", text: response.data.message, icon: "error", button: true });
                    this.setState({ loading: false });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                if (error.response?.status === 406) {
                    swal({
                        title: "Could not save visit",
                        text: 'Visit with the same date already exists',
                        icon: 'error',
                        button: true
                    });
                } else {
                    this.handleApiError(error);
                }
            });
    }

    // Update expiry date
    updateExpiryDate(e) {
        e.preventDefault();
        this.setState({ loading: true });

        axios.patch(API_URL + `/inspection_visits/update/${this.state.visit.visit_id}`,
            { expiry_date: this.state.expiry_date },
            {
                headers: { "Authorization": `Bearer ${this.state.bearer_auth}` }
            })
            .then(response => {
                if (response.status === 200) {
                    swal({
                        title: "Success",
                        text: "Visit updated successfully!",
                        icon: "success",
                        timer: 2500,
                        buttons: false
                    }).then(() => {
                        this.setState({
                            EditAdminModalVisible: false,
                            showOptions: true,
                            toggleCalendar: false,
                            expiry_date: '',
                            loading: false
                        });
                        this.fetchData();
                    });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                this.handleApiError(error);
            });
    }

    // Stepper functions
    steps = ['School', 'School Details', 'Inspector Details'];

    totalSteps = () => this.steps.length;

    completedSteps = () => Object.keys(this.state.completed).length;

    isLastStep = () => this.state.activeStep === this.totalSteps() - 1;

    allStepsCompleted = () => this.completedSteps() === this.totalSteps();

    handleNext = () => {
        if (this.isLastStep() && this.allStepsCompleted()) {
            return this.addInspectionVisit();
        }
        const newActiveStep = this.state.activeStep + 1;
        this.setState({ activeStep: newActiveStep });
    };

    handleBack = () => {
        const newCompleted = { ...this.state.completed };
        delete newCompleted[this.state.activeStep - 1];
        this.setState({
            completed: newCompleted,
            activeStep: this.state.activeStep - 1
        });
    };

    handleComplete = () => {
        // Validate current step
        let isValid = true;
        let errorMessage = '';

        if (this.state.activeStep === 0) {
            const step0Fields = ['DivisionIdState', 'DistrictIdState', 'ZoneIdState', 'EmisIdState'];
            const invalidFields = step0Fields.filter(field =>
                [undefined, 'has-danger'].includes(this.state[field])
            );
            if (invalidFields.length > 0) {
                isValid = false;
                errorMessage = "Please make sure all fields in School section are valid";
            }
        } else if (this.state.activeStep === 1) {
            const step1Fields = ['PhoneState', 'SchoolAddressState', 'EstYearState', 'EstState',
                'EnrolledBoysState', 'EnrolledGirlsState', 'TotalTeachersState',
                'UnqualifiedTeachersState'];
            const invalidFields = step1Fields.filter(field =>
                [undefined, 'has-danger'].includes(this.state[field])
            );
            if (invalidFields.length > 0) {
                isValid = false;
                errorMessage = "Please make sure all fields in School Details section are valid";
            }
        } else if (this.state.activeStep === 2) {
            const inspectors = [
                this.state.lead_inspector_id,
                this.state.first_inspector_id,
                this.state.second_inspector_id,
                this.state.third_inspector_id,
                this.state.fourth_inspector_id
            ];
            if (!inspectors.includes(this.state.logged_user_id)) {
                isValid = false;
                errorMessage = "Current user must be present in the Inspection Team";
            }
            const step2Fields = ['leadInspectorIdState', 'firstInspectorIdState', 'secondInspectorIdState',
                'leadAdvisorIdState', 'govChairIdState'];
            const invalidFields = step2Fields.filter(field =>
                [undefined, 'has-danger'].includes(this.state[field])
            );
            if (invalidFields.length > 0) {
                isValid = false;
                errorMessage = "Please make sure all required fields in Inspector Details section are valid";
            }
        }

        if (!isValid) {
            return swal({
                title: '',
                text: errorMessage,
                icon: "error"
            });
        }

        // Mark current step as completed
        const newCompleted = { ...this.state.completed };
        newCompleted[this.state.activeStep] = true;
        this.setState({ completed: newCompleted }, () => {
            // If this is the last step, submit the form
            if (this.isLastStep()) {
                if (this.state.EditModalVisible) {
                    this.updateInspectionVisit();
                } else {
                    this.addInspectionVisit();
                }
            } else {
                // Otherwise, go to next step
                const newActiveStep = this.state.activeStep + 1;
                this.setState({ activeStep: newActiveStep });
            }
        });
    };

    handleReset = () => {
        this.setState({
            completed: {},
            activeStep: 0
        });
    };

    render() {
        const {
            Visits, Divisions, Users, loading, isFetching, modalVisible,
            EditAdminModalVisible, role, activeStep, completed, sector_id,
            error, totalCount, jurisdiction, Districts, Zones, Schools,
            years, EditModalVisible
        } = this.state;

        const columns = [

            {
                title: 'School',
                field: 'school_name',
                render: rowData => (
                    <div>
                        <div><strong>{rowData.school_name}</strong></div>
                        <small className="text-muted">EMIS: {rowData.emis_id || 'N/A'}</small>
                    </div>
                )
            },
            {
                title: 'Date',
                field: 'present_visitation_date',
                width: 120,
                render: rowData => (
                    <div>
                        <div>{new Date(rowData.present_visitation_date).toLocaleDateString()}</div>
                        <small className="text-muted">
                            {rowData.visit_type_description || 'Inspection'}
                        </small>
                    </div>
                )
            },
            {
                title: 'Head Teacher',
                field: 'head_teacher',
                width: 150,
                render: rowData => (
                    <div>
                        <div>{rowData.head_teacher}</div>
                        <small className="text-muted">
                            {this.formatPhoneNumber(rowData.phone_number)}
                        </small>
                    </div>
                )
            },
            {
                title: 'Location',
                field: 'zone_name',
                width: 180,
                render: rowData => (
                    <div>
                        <div>{rowData.zone_name} {sector_id == 1 ? 'Zone' : 'Cluster'}</div>
                        <small className="text-muted">
                            {rowData.district_name} • {rowData.division_name}
                        </small>
                    </div>
                )
            },
            {
                title: 'Status',
                field: 'expiry_date',
                width: 120,
                render: rowData => {
                    const status = this.getVisitStatus(rowData.expiry_date);
                    return (
                        <Badge color={status.color} className="px-2 py-1">
                            {status.text}
                        </Badge>
                    );
                }
            },
            {
                title: 'Actions',
                field: 'actions',
                export: false,
                sorting: false,
                width: 200,
                render: rowData => (
                    <div className="d-flex">
                        {/* View Details Button */}
                        <Button
                            color="link"
                            size="sm"
                            onClick={() => this.viewVisitDetails(rowData)}
                            title="View Details"
                            className="mr-1"
                        >
                            <i className="mdi mdi-eye-outline text-info"></i>
                        </Button>

                        {/* Edit button for inspectors */}
                        {role === 'Inspector' &&
                            (this.state.logged_user_id === rowData.lead_inspector_id ||
                                this.state.logged_user_id === rowData.first_inspector_id ||
                                this.state.logged_user_id === rowData.second_inspector_id) &&
                            new Date(rowData.expiry_date) >= new Date() && (
                                <Button
                                    color="link"
                                    size="sm"
                                    onClick={() => this.editInspectionVisit(rowData.visit_id)}
                                    title="Edit Visit"
                                    className="mr-1"
                                >
                                    <Edit className="text-primary" />
                                </Button>
                            )}

                        {/* Delete button for inspectors */}
                        {role === 'Inspector' &&
                            (this.state.logged_user_id === rowData.lead_inspector_id ||
                                this.state.logged_user_id === rowData.first_inspector_id ||
                                this.state.logged_user_id === rowData.second_inspector_id) &&
                            new Date(rowData.expiry_date) >= new Date() && (
                                <Button
                                    color="link"
                                    size="sm"
                                    onClick={() => this.deleteInspectionVisit(rowData.visit_id)}
                                    title="Delete Visit"
                                    className="mr-1"
                                >
                                    <Delete className="text-danger" />
                                </Button>
                            )}

                        {/* Edit button for System Administrator */}
                        {role === 'System Administrator' && (
                            <Button
                                color="link"
                                size="sm"
                                onClick={() => this.toggleAdminEdit(rowData)}
                                title="Admin Edit"
                                className="mr-1"
                            >
                                <Edit className="text-warning" />
                            </Button>
                        )}

                        {/* More options button */}
                        {(role === 'Inspector' || role === 'PEA' ||
                            role === 'Secondary Advisor' || role === 'Head Teacher') && (
                                <Link
                                    className="btn btn-primary btn-sm"
                                    to={`/inspection_panel/${rowData.visit_id}&${new Date(rowData.expiry_date) < new Date()}&${this.state.logged_user_id}&${rowData.lead_inspector_id}&${rowData.first_inspector_id}`}
                                    title="More Options"
                                >
                                    <i className="mdi mdi-dots-horizontal"></i>
                                </Link>
                            )}
                    </div>
                )
            }
        ];

        // Calculate statistics
        const activeVisits = Visits.filter(v => this.getVisitStatus(v.expiry_date).color === 'success').length;
        const expiringVisits = Visits.filter(v => this.getVisitStatus(v.expiry_date).color === 'warning').length;
        const expiredVisits = Visits.filter(v => this.getVisitStatus(v.expiry_date).color === 'danger').length;

        return (
            <Container fluid>
                {/* {isFetching && <Loader />} */}

                {/* Page Header */}
                <Row className="align-items-center mb-4">
                    <Col sm={6}>
                        <div className="page-title-box">
                            <h4 className="page-title mb-0">
                                <i className="mdi mdi-school mr-2"></i>
                                Inspection Visits
                            </h4>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Home</Link>
                                </li>
                                <li className="breadcrumb-item active">Inspection Visits</li>
                            </ol>
                        </div>
                    </Col>
                    <Col sm={6} className="text-right">
                        <Button
                            color="success"
                            onClick={this.toggle}
                            disabled={role !== 'Inspector'}
                            className="mr-2"
                        >
                            <Add /> New Inspection Visit
                        </Button>
                        <div className="badge badge-light p-2">
                            <i className="mdi mdi-counter mr-1"></i>
                            {totalCount.toLocaleString()} Total Visits
                        </div>
                    </Col>
                </Row>

                {error && (
                    <Row className="mb-3">
                        <Col>
                            <Alert color="danger">
                                <h5 className="alert-heading">Error Loading Data</h5>
                                <p>{error}</p>
                            </Alert>
                        </Col>
                    </Row>
                )}

                {/* Main Content */}
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="card-title mb-0">{jurisdiction}</h5>
                                    <div className="d-flex">
                                        <Badge color="success" className="mr-2 px-2">Active</Badge>
                                        <Badge color="warning" className="mr-2 px-2">Expiring</Badge>
                                        <Badge color="danger" className="px-2">Expired</Badge>
                                    </div>
                                </div>

                                <p className="text-muted mb-4">
                                    Manage school inspection visits, track status, and view inspection details.
                                </p>

                                {/* Material Table with Optimized Pagination */}
                                <MaterialTable
                                    tableRef={this.tableRef}
                                    title="Inspection Visits"
                                    columns={columns}
                                    data={query => {
                                        return new Promise((resolve, reject) => {
                                            const page = query.page;
                                            const pageSize = query.pageSize;
                                            const search = query.search || '';

                                            this.fetchData(page, pageSize, search)
                                                .then(() => {
                                                    resolve({
                                                        data: this.state.Visits,
                                                        page: this.state.page,
                                                        totalCount: this.state.totalCount
                                                    });
                                                })
                                                .catch(error => {
                                                    reject(error);
                                                });
                                        });
                                    }}
                                    // isLoading={isFetching}
                                    loadingType="overlay"
                                    options={{
                                        exportButton: {
                                            csv: true,
                                            pdf: false
                                        },
                                        exportFileName: `inspection-visits-${moment().format('YYYY-MM-DD')}`,
                                        tableLayout: 'auto',
                                        // loadingType: 'linear',
                                        pageSize: this.state.pageSize,
                                        pageSizeOptions: [5, 10, 20, 50, 100],
                                        emptyRowsWhenPaging: false,
                                        columnsButton: true,
                                        exportAllData: false,
                                        actionsColumnIndex: -1,
                                        search: true,

                                        sorting: true,
                                        debounceInterval: 500,
                                        showFirstLastPageButtons: true,
                                        paginationType: 'normal',
                                        padding: 'dense',
                                        rowStyle: {
                                            fontSize: '0.9rem'
                                        },
                                        headerStyle: {
                                            backgroundColor: '#f8f9fa',
                                            fontWeight: '600',
                                            fontSize: '0.9rem'
                                        },
                                        paging: true,
                                        serverSide: true,
                                        pagingPosition: 'bottom'
                                    }}
                                    localization={{
                                        body: {
                                            emptyDataSourceMessage: 'No inspection visits found. Create a new visit to get started.',
                                            addTooltip: 'Add',
                                            deleteTooltip: 'Delete',
                                            editTooltip: 'Edit',
                                            filterRow: {
                                                filterTooltip: 'Filter'
                                            }
                                        },
                                        pagination: {
                                            labelRowsSelect: 'rows per page',
                                            labelDisplayedRows: '{from}-{to} of {count}',
                                            firstTooltip: 'First Page',
                                            previousTooltip: 'Previous Page',
                                            nextTooltip: 'Next Page',
                                            lastTooltip: 'Last Page'
                                        },
                                        toolbar: {
                                            searchTooltip: 'Search inspection visits',
                                            searchPlaceholder: 'Search by school, head teacher, or location...',
                                            exportTitle: 'Export',
                                            exportName: 'Export as CSV',
                                            exportCSVName: 'Export as CSV'
                                        },
                                        header: {
                                            actions: 'Actions'
                                        }
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Stats Card */}
                <Row className="mt-3">
                    <Col>
                        <Card className="border">
                            <CardBody className="py-3">
                                <Row>
                                    <Col md={3} className="text-center border-right">
                                        <h4 className="mb-1 text-primary">{totalCount.toLocaleString()}</h4>
                                        <small className="text-muted">Total Visits</small>
                                    </Col>
                                    <Col md={3} className="text-center border-right">
                                        <h4 className="mb-1 text-success">{activeVisits}</h4>
                                        <small className="text-muted">Active Visits</small>
                                    </Col>
                                    <Col md={3} className="text-center border-right">
                                        <h4 className="mb-1 text-warning">{expiringVisits}</h4>
                                        <small className="text-muted">Expiring Soon</small>
                                    </Col>
                                    <Col md={3} className="text-center">
                                        <h4 className="mb-1 text-danger">{expiredVisits}</h4>
                                        <small className="text-muted">Expired Visits</small>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Add/Edit Inspection Visit Modal */}
                <Modal isOpen={modalVisible} toggle={this.toggle} size="lg">
                    <Form onSubmit={(e) => { e.preventDefault(); this.addInspectionVisit(); }}>
                        <ModalHeader toggle={this.toggle}>
                            <center>INSPECTION VISIT {EditModalVisible ? 'EDITING' : 'ADDITION'} FORM</center>
                        </ModalHeader>
                        <ModalBody>
                            <Box sx={{ width: '100%' }}>
                                <Stepper nonLinear activeStep={activeStep}>
                                    {this.steps.map((label, index) => (
                                        <Step key={label} completed={completed[index]}>
                                            <StepButton color="inherit" onClick={() => this.setState({ activeStep: index })}>
                                                {label}
                                            </StepButton>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>

                            <div style={{ marginTop: '3em' }}>
                                {/* Step 1: School Selection */}
                                {activeStep === 0 && (
                                    <>
                                        <FormGroup>
                                            <Label for="division_id">Division Name <span className="text-danger">*</span></Label>
                                            <Input
                                                type="select"
                                                name="division_id"
                                                id="division_id"
                                                value={this.state.division_id}
                                                onChange={(e) => { this.handleInput(e); this.filterDistrictsAfterLoad(e); }}
                                                invalid={this.state.DivisionIdState === 'has-danger'}
                                                required
                                            >
                                                <option value="">Select Division</option>
                                                {Divisions.map(division => (
                                                    <option key={division.division_id} value={division.division_id}>
                                                        {division.division_name}
                                                    </option>
                                                ))}
                                            </Input>
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="district_id">District Name <span className="text-danger">*</span></Label>
                                            <Input
                                                type="select"
                                                name="district_id"
                                                id="district_id"
                                                value={this.state.district_id}
                                                onChange={(e) => { this.handleInput(e); this.filterZonesAfterLoad(e); }}
                                                invalid={this.state.DistrictIdState === 'has-danger'}
                                                required
                                                disabled={!Districts.length}
                                            >
                                                <option value="">Select District</option>
                                                {Districts.map(district => (
                                                    <option key={district.district_id} value={district.district_id}>
                                                        {district.district_name}
                                                    </option>
                                                ))}
                                            </Input>
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="zone_id">
                                                {this.state.sector_id == 1 ? 'Zone' : 'Cluster'} Name <span className="text-danger">*</span>
                                            </Label>
                                            <Input
                                                type="select"
                                                name="zone_id"
                                                id="zone_id"
                                                value={this.state.zone_id}
                                                onChange={(e) => { this.handleInput(e); this.filterSchoolsAfterLoad(e); }}
                                                invalid={this.state.ZoneIdState === 'has-danger'}
                                                required
                                                disabled={!Zones.length}
                                            >
                                                <option value="">Select {this.state.sector_id == 1 ? 'Zone' : 'Cluster'}</option>
                                                {Zones
                                                    .filter(zone => !this.state.sector_id || zone.sector_id == this.state.sector_id)
                                                    .map(zone => (
                                                        <option key={zone.zone_id} value={zone.zone_id}>
                                                            {zone.zone_name}
                                                        </option>
                                                    ))}
                                            </Input>
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="school_id">School Name <span className="text-danger">*</span></Label>
                                            <Input
                                                type="select"
                                                name="school_id"
                                                id="school_id"
                                                value={this.state.school_id}
                                                onChange={(e) => { this.handleInput(e); this.getRecentVisitBySchool(e); }}
                                                invalid={this.state.EmisIdState === 'has-danger'}
                                                required
                                                disabled={!Schools.length}
                                            >
                                                <option value="">Select School</option>
                                                {Schools.map(school => (
                                                    <option key={school.school_id} value={school.school_id}>
                                                        {school.school_name}
                                                    </option>
                                                ))}
                                            </Input>
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>
                                    </>
                                )}

                                {/* Step 2: School Details */}
                                {activeStep === 1 && (
                                    <>
                                        <FormGroup>
                                            <Label for="head_teacher">Head Teacher <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                name="head_teacher"
                                                id="head_teacher"
                                                value={this.state.head_teacher}
                                                onChange={this.handleInput}
                                                invalid={this.state.HeadTeacherIdState === 'has-danger'}
                                                required
                                            />
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="phone_number">Head Teacher's Phone <span className="text-danger">*</span></Label>
                                            <InputGroup>
                                                <InputGroupText>+265</InputGroupText>
                                                <Input
                                                    type="number"
                                                    name="phone_number"
                                                    id="phone_number"
                                                    value={this.state.phone_number}
                                                    onChange={this.handleInput}
                                                    invalid={this.state.PhoneState === 'has-danger'}
                                                    required
                                                />
                                            </InputGroup>
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <FormGroup>
                                            <Label for="school_address">Postal Address <span className="text-danger">*</span></Label>
                                            <Input
                                                type="textarea"
                                                name="school_address"
                                                id="school_address"
                                                value={this.state.school_address}
                                                onChange={this.handleInput}
                                                invalid={this.state.SchoolAddressState === 'has-danger'}
                                                required
                                                rows="2"
                                            />
                                            <FormFeedback invalid>The field is required.</FormFeedback>
                                        </FormGroup>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="establishment_year">Year Of Establishment <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        name="establishment_year"
                                                        id="establishment_year"
                                                        value={this.state.establishment_year}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.EstYearState === 'has-danger'}
                                                        required
                                                    >
                                                        <option value="">Select Year</option>
                                                        {years.map(year => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </Input>
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="establishment">Establishment <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        name="establishment"
                                                        id="establishment"
                                                        value={this.state.establishment}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.EstState === 'has-danger'}
                                                        required
                                                    >
                                                        <option value="">Select Establishment</option>
                                                        {this.state.sector_id == 2 ? (
                                                            ["Form 1-4", "Form 1-2", "Form 3-4"].map(est => (
                                                                <option key={est} value={est}>{est}</option>
                                                            ))
                                                        ) : (
                                                            ["Full Primary", "LEA"].map(est => (
                                                                <option key={est} value={est}>{est}</option>
                                                            ))
                                                        )}
                                                    </Input>
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="number_of_teachers">Number of Qualified Teachers <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="number_of_teachers"
                                                        id="number_of_teachers"
                                                        value={this.state.number_of_teachers}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.TotalTeachersState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="unqualified_teachers">Number of Un-Qualified Teachers <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="unqualified_teachers"
                                                        id="unqualified_teachers"
                                                        value={this.state.unqualified_teachers}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.UnqualifiedTeachersState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="enrolment_boys">Total Enrolled Boys <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="enrolment_boys"
                                                        id="enrolment_boys"
                                                        value={this.state.enrolment_boys}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.EnrolledBoysState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="enrolment_girls">Total Enrolled Girls <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="enrolment_girls"
                                                        id="enrolment_girls"
                                                        value={this.state.enrolment_girls}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.EnrolledGirlsState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="attendance_boys">Total Attendance (Boys) <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="attendance_boys"
                                                        id="attendance_boys"
                                                        value={this.state.attendance_boys}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.AttendanceBoysState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>{this.state.attendanceError}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="attendance_girls">Total Attendance (Girls) <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="number"
                                                        min="0"
                                                        name="attendance_girls"
                                                        id="attendance_girls"
                                                        value={this.state.attendance_girls}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.AttendanceGirlsState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>{this.state.attendanceGirlsError}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {/* Step 3: Inspector Details */}
                                {activeStep === 2 && (
                                    <>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="lead_inspector_id">Lead Inspector <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        name="lead_inspector_id"
                                                        id="lead_inspector_id"
                                                        value={this.state.lead_inspector_id}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.leadInspectorIdState === 'has-danger'}
                                                        required
                                                    >
                                                        <option value="">Select Lead Inspector</option>
                                                        {Users
                                                            .filter(user => user.sector_id == this.state.sector_id &&
                                                                user.user_role === 'Inspector' &&
                                                                user.user_id !== this.state.first_inspector_id &&
                                                                user.user_id !== this.state.second_inspector_id &&
                                                                user.user_id !== this.state.third_inspector_id &&
                                                                user.user_id !== this.state.fourth_inspector_id)
                                                            .map(user => (
                                                                <option key={user.user_id} value={user.user_id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                    </Input>
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="first_inspector_id">First Inspector <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        name="first_inspector_id"
                                                        id="first_inspector_id"
                                                        value={this.state.first_inspector_id}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.firstInspectorIdState === 'has-danger'}
                                                        required
                                                    >
                                                        <option value="">Select First Inspector</option>
                                                        {Users
                                                            .filter(user => user.sector_id == this.state.sector_id &&
                                                                user.user_role === 'Inspector' &&
                                                                user.user_id !== this.state.lead_inspector_id &&
                                                                user.user_id !== this.state.second_inspector_id &&
                                                                user.user_id !== this.state.third_inspector_id &&
                                                                user.user_id !== this.state.fourth_inspector_id)
                                                            .map(user => (
                                                                <option key={user.user_id} value={user.user_id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                    </Input>
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="second_inspector_id">Second Inspector <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        name="second_inspector_id"
                                                        id="second_inspector_id"
                                                        value={this.state.second_inspector_id}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.secondInspectorIdState === 'has-danger'}
                                                        required
                                                    >
                                                        <option value="">Select Second Inspector</option>
                                                        {Users
                                                            .filter(user => user.sector_id == this.state.sector_id &&
                                                                user.user_role === 'Inspector' &&
                                                                user.user_id !== this.state.lead_inspector_id &&
                                                                user.user_id !== this.state.first_inspector_id &&
                                                                user.user_id !== this.state.third_inspector_id &&
                                                                user.user_id !== this.state.fourth_inspector_id)
                                                            .map(user => (
                                                                <option key={user.user_id} value={user.user_id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                    </Input>
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="third_inspector_id">Third Inspector</Label>
                                                    <Input
                                                        type="select"
                                                        name="third_inspector_id"
                                                        id="third_inspector_id"
                                                        value={this.state.third_inspector_id}
                                                        onChange={this.handleInput}
                                                    >
                                                        <option value="">Select Third Inspector</option>
                                                        {Users
                                                            .filter(user => user.sector_id == this.state.sector_id &&
                                                                user.user_role === 'Inspector' &&
                                                                user.user_id !== this.state.lead_inspector_id &&
                                                                user.user_id !== this.state.first_inspector_id &&
                                                                user.user_id !== this.state.second_inspector_id &&
                                                                user.user_id !== this.state.fourth_inspector_id)
                                                            .map(user => (
                                                                <option key={user.user_id} value={user.user_id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="fourth_inspector_id">Fourth Inspector</Label>
                                                    <Input
                                                        type="select"
                                                        name="fourth_inspector_id"
                                                        id="fourth_inspector_id"
                                                        value={this.state.fourth_inspector_id}
                                                        onChange={this.handleInput}
                                                    >
                                                        <option value="">Select Fourth Inspector</option>
                                                        {Users
                                                            .filter(user => user.sector_id == this.state.sector_id &&
                                                                user.user_role === 'Inspector' &&
                                                                user.user_id !== this.state.lead_inspector_id &&
                                                                user.user_id !== this.state.first_inspector_id &&
                                                                user.user_id !== this.state.second_inspector_id &&
                                                                user.user_id !== this.state.third_inspector_id)
                                                            .map(user => (
                                                                <option key={user.user_id} value={user.user_id}>
                                                                    {user.user_name}
                                                                </option>
                                                            ))}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="present_visitation_date">Present Visitation Date <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="date"
                                                        name="present_visitation_date"
                                                        id="present_visitation_date"
                                                        value={this.state.present_visitation_date}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.presentDateState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>
                                                        The field is required and cannot be a future date.
                                                    </FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="lead_advisor_id">Advisor <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="lead_advisor_id"
                                                        id="lead_advisor_id"
                                                        value={this.state.lead_advisor_id}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.leadAdvisorIdState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Label for="govt_chair_id">School Governance Chair <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="govt_chair_id"
                                                        id="govt_chair_id"
                                                        value={this.state.govt_chair_id}
                                                        onChange={this.handleInput}
                                                        invalid={this.state.govChairIdState === 'has-danger'}
                                                        required
                                                    />
                                                    <FormFeedback invalid>The field is required.</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={this.handleBack}
                            >
                                Back
                            </Button>
                            <Button
                                color="success"
                                onClick={this.handleComplete}
                                disabled={loading}
                            >
                                {loading ? 'Processing...' :
                                    this.isLastStep() ?
                                        (EditModalVisible ? 'Update' : 'Create') : 'Next'}
                            </Button>
                            <Button color="danger" onClick={this.toggle}>Cancel</Button>
                        </ModalFooter>
                    </Form>
                </Modal>

                {/* Admin Edit Modal */}
                <Modal isOpen={EditAdminModalVisible} toggle={() => this.toggleAdminEdit()}>
                    <ModalHeader toggle={() => this.toggleAdminEdit()}>
                        <center>{this.state.visit?.school_name || 'Edit Visit'}</center>
                    </ModalHeader>
                    <Form onSubmit={this.updateExpiryDate}>
                        <ModalBody>
                            {this.state.showOptions ? (
                                <>
                                    <p>WHAT ARE YOU UPDATING?</p>
                                    <div className="list-group">
                                        <button
                                            type="button"
                                            className="list-group-item list-group-item-action"
                                            onClick={this.toggleUpdateExpiryDate}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            Update expiry date
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <p style={{ fontWeight: 'bold' }}>
                                        UPDATE VISIT EXPIRY DATE FOR {this.state.visit?.school_name}
                                    </p>
                                    <FormGroup>
                                        <Label for="expiry_date">Expiry Date</Label>
                                        <Input
                                            type="date"
                                            name="expiry_date"
                                            id="expiry_date"
                                            value={this.state.expiry_date}
                                            onChange={this.handleInput}
                                            invalid={this.state.ExpiryVisitDate === 'has-danger'}
                                            required
                                        />
                                        <FormFeedback invalid>{this.state.expiryDateMessage}</FormFeedback>
                                    </FormGroup>
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button type="submit" color="success" disabled={loading}>
                                {loading ? 'Processing...' : 'Update'}
                            </Button>
                            <Button color="danger" onClick={() => this.toggleAdminEdit()}>Cancel</Button>
                        </ModalFooter>
                    </Form>
                </Modal>
            </Container>
        );
    }
}

export default InspectionVisits;